















































































































































































import {
  apiOrderOrderCancel,
  apiOrderOrderPay,
  ApiOrderWriteOffOrderListResponse,
} from '@/api'
import { computed } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent } from '@/hooks'
import { Dialog, Toast } from 'vant'
import { globalModel } from '@/model'
import { ItemOf, submit } from '@/utils'
import { navigateTo } from '@/router'

export default defineClassComponent<{
  value: ItemOf<ApiOrderWriteOffOrderListResponse>
  fromDetail: boolean
}>(
  {
    props: ['value', 'fromDetail'],
  },
  ({ props, ctx }) =>
    class {
      // 订单状态
      status = computed(() => props.value.status)

      // 是否组合订单
      isJoint = computed(() => props.value.orderClassify === 5)

      // 点击取消订单
      handleCancelClick = () => {
        submit(async $ => {
          await Dialog.confirm({
            title: '温馨提示',
            message: '确定取消此订单吗？',
          })
          await $.start()
          await apiOrderOrderCancel({
            orderNo: props.value.orderNo,
          })
          ctx.$emit('refresh')
          navigateTo('OrderCancelResult')
        })
      }

      // 点击售后
      handleTipsClick = () => {
        Dialog.confirm({
          title: '温馨提示',
          message:
            '当前订单已经完结，不支持在线售后，相关问题可联系平台客服处理。',
          showCancelButton: false,
          confirmButtonText: '我知道了',
        })
      }

      // 去支付
      handlePayClick = () => {
        submit(async $ => {
          await $.start()
          const payData = await apiOrderOrderPay({
            orderNo: props.value.orderNo,
            payType: globalModel.state.payType as any,
            openId: globalModel.state.openid,
          })
          // if (Number(payData.payType) === 12) {
          //   // @ts-ignore
          //   const payUrl = payData.thirdParams.payUrl.replace(
          //     'SUCURL',
          //     encodeURIComponent(getCurrentPageUrl()),
          //   )
          //   const off = onPageVisibilityChange(visible => {
          //     if (visible) {
          //       off()
          //       ctx.$emit('refresh')
          //     }
          //   })
          //   dcb.navigateTo({
          //     url: payUrl,
          //   })
          // } else {
          await dcb.requestPayment({
            provider: 'native',
            showNativeResultPage: false,
            params: payData,
          })
          ctx.$emit('refresh')
          await $.success('支付成功')
          // }
        })
      }

      // 申请退款
      handleRequestRefundClick = () => {
        navigateTo('BookRefundRequest', {
          orderNo: props.value.orderNo,
        })
      }

      // 查看详情
      handleDetailClick = () => {
        navigateTo('BookOrderDetail', {
          orderNo: props.value.orderNo,
        })
      }

      // 去评价
      handleCommentClick = () => {
        // navigateTo('BookCommentAdd', {
        //   orderNo: props.value.orderNo,
        // })

        navigateTo('OrderComment', {
          orderNo: props.value.orderNo,
          isEvaluateAdd: props.value.evaluationStatus === 2,
        })
      }

      // 查看评价
      lookCommentClick = () => {
        navigateTo('UserComment')
      }

      // 评价审核中
      handleEvaluateTip = () => {
        Toast('评论正在审核中！')
      }

      // 再来一单
      handleAgainClick = () => {
        navigateTo(
          props.value.orderClassify === 6
            ? 'TravelGoodsIndex'
            : props.value.orderClassify === 5
            ? 'JointGoodsIndex'
            : 'BookGoodsIndex',
          {
            goodsId: props.value.commodityId,
          },
        )
      }

      // 退款进度
      handleRefundClick = () => {
        navigateTo('BookRefundResult', {
          refundId: props.value.orderNo,
        })
      }
    },
)
